<div>
  <header
    [ngClass]="{
      dark: components[currentComponentIndex].header.isDarkBackground
    }"
  >
    <button (click)="close()" class="btn btn-lg" type="button">
      <i class="fa-solid fa-arrow-left"></i>
    </button>
    <div class="d-flex align-items-end justify-content-between">
      <h5
        [ngClass]="{
          center: components[currentComponentIndex].header.isTitleCenter
        }"
      >
        {{ components[currentComponentIndex].header.title }}
      </h5>
      <img
        [src]="
          components[currentComponentIndex].header.isDarkBackground
            ? '../../../assets/logo-rsm-white.svg'
            : '../../../assets/logo-rsm-black.svg'
        "
        alt="RSM Logo"
      />
    </div>
  </header>
  <div class="content-container">
    <ng-container
      *ngComponentOutlet="components[currentComponentIndex].component"
    ></ng-container>
  </div>
</div>
